export enum ImageTypeEnum {
  TemplateBefore = 0,
  TemplateAfter = 1,
  ImageBefore = 2,
  ImageAfter = 3,
  AgreementImage = 4,
  StoreCMS = 5
}